/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUserToWorkspaceSchema
 */
export interface AddUserToWorkspaceSchema {
    /**
     * 
     * @type {number}
     * @memberof AddUserToWorkspaceSchema
     */
    workspaceId: number;
    /**
     * 
     * @type {number}
     * @memberof AddUserToWorkspaceSchema
     */
    coreLimit: number;
    /**
     * 
     * @type {number}
     * @memberof AddUserToWorkspaceSchema
     */
    creditLimit: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddUserToWorkspaceSchema
     */
    isAdmin: boolean;
}

/**
 * Check if a given object implements the AddUserToWorkspaceSchema interface.
 */
export function instanceOfAddUserToWorkspaceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "workspaceId" in value;
    isInstance = isInstance && "coreLimit" in value;
    isInstance = isInstance && "creditLimit" in value;
    isInstance = isInstance && "isAdmin" in value;

    return isInstance;
}

export function AddUserToWorkspaceSchemaFromJSON(json: any): AddUserToWorkspaceSchema {
    return AddUserToWorkspaceSchemaFromJSONTyped(json, false);
}

export function AddUserToWorkspaceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserToWorkspaceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceId': json['workspace_id'],
        'coreLimit': json['core_limit'],
        'creditLimit': json['credit_limit'],
        'isAdmin': json['is_admin'],
    };
}

export function AddUserToWorkspaceSchemaToJSON(value?: AddUserToWorkspaceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspace_id': value.workspaceId,
        'core_limit': value.coreLimit,
        'credit_limit': value.creditLimit,
        'is_admin': value.isAdmin,
    };
}

